import styled from 'styled-components';
import { SpinnerMixin } from '../../mixins/components/SpinnerMixin';
export var StyledSpinner = /*#__PURE__*/styled.svg.withConfig({
  displayName: "StyledSpinner",
  componentId: "c11n-8-107-0__sc-1qy1aqr-0"
})(["", ""], SpinnerMixin);